"use client";
import { Color, SingleProductQuery } from "@/__generated__/sdk";
import { Card, CardActionArea, Popover, Popper, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import _ from "lodash";
import React from "react";
import { Check, CheckBoxOutlineBlank } from "@mui/icons-material";

function ColorBox({ color, selected, onChange }: { color: Color; selected: boolean; onChange: (id: number) => void }) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Card
        elevation={0}
        sx={{
          border: 2,
          boxSizing: "border-box",
          borderColor: selected ? "secondary.main" : "grey.200",
          borderRadius: 200,
          borderStyle: "solid",
          transition: "0.1s all ease",
          cursor: "pointer",
          width: 36,
          height: 36,
        }}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={() => {
          onChange(color.id);
        }}
      >
        <CardActionArea
          aria-label={`color Action ${color.id}`}
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              background: color.hex,
              height: "100%",
              width: "100%",
              display: "flex",
              borderRadius: 2000,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {selected && (
              <>
                <Check
                  sx={{
                    color: "secondary.main",
                    textShadow: "0px 0px 2px 1px rgba(0,0,0,1)",
                  }}
                />
              </>
            )}
          </Box>
        </CardActionArea>
      </Card>
      <Popper sx={{ pointerEvents: "none" }} open={open} anchorEl={anchorEl} placement={"top"}>
        <Card
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 1,
            py: 0.2,
            my: 0.4,
          }}
        >
          <Typography variant="body2">{color.title}</Typography>
        </Card>
      </Popper>
    </>
  );
}

type Props = {
  colors: Color[];
  value: number;
  onChange: (value: number) => void;
};
export default function ProductVariantsSectionColorsSelect({ colors, value, onChange }: Props) {
  return (
    <Stack spacing={0.5}>
      <Stack direction={"row"} alignItems={"center"} spacing={1}>
        <Typography variant={"subtitle2"} color={"grey.700"} component={"div"}>
          رنگ :
        </Typography>
        <Typography variant={"subtitle2"} color={"grey.800"} component={"div"}>
          {colors.find((a) => a.id === value)?.title || ""}
        </Typography>
      </Stack>
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
        {colors &&
          colors.length > 0 &&
          colors.map((a) => {
            const selected = value === a.id;
            return (
              <ColorBox
                key={a.id}
                selected={selected}
                color={a}
                onChange={(id) => {
                  onChange(id);
                }}
              ></ColorBox>
            );
          })}
      </Box>
    </Stack>
  );
}
